import React from 'react'
import Icon from '../../misc/icon'
import { ButtonGroup } from 'reactstrap'
import Button from '../../buttons/button'
import _ from 'lodash'
import { ContextType } from '../types/advanced-grid.types'
import { withGridContext } from '../providers'

interface Props {
    gridId: string | number
    pages: number
}
/**
 * Component to render the pagination as buttons
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const ButtonPager: React.FC<Props & ContextType> = ({
    currentPage,
    events,
    gridId,
    pages,
    resetCheckAll
}) => {
    const { handleChangeCurrentPage, handleNextPage, handlePreviousPage } = events || {}
    const handleGoToPage = (key: number) => {
        if (handleChangeCurrentPage) {
            handleChangeCurrentPage(key)
        }
        if (resetCheckAll) {
            resetCheckAll()
        }
    }
    const handleGoFirst = () => {
        if (handleChangeCurrentPage) {
            handleChangeCurrentPage(0)
        }
        if (resetCheckAll) {
            resetCheckAll()
        }
    }
    const handleGoLast = () => {
        if (handleChangeCurrentPage) {
            handleChangeCurrentPage(pages - 1)
        }
        if (resetCheckAll) {
            resetCheckAll()
        }
    }
    const current = currentPage ? currentPage : 1
    const canGoBack = current > 1
    const canGoForward = current < pages
    return (
        <ButtonGroup>
            {Boolean(canGoBack) && (
                <>
                    <Button disabled={!canGoBack} color="link" onClick={handleGoFirst} size="sm">
                        <Icon type="step-backward" size="sm" />
                    </Button>
                    <Button color="link" onClick={handlePreviousPage} size="size">
                        <Icon type="backward" size="sm" />
                    </Button>
                </>
            )}
            {_.times(pages || 0, (key) => {
                const colorType = key + 1 === current ? 'secondary' : 'link'
                return (
                    <Button
                        color={colorType}
                        key={`${key}-${gridId}-page`}
                        onClick={() => handleGoToPage(key)}
                        size="sm"
                    >
                        {key + 1}
                    </Button>
                )
            })}
            {Boolean(canGoForward) && (
                <>
                    <Button color="link" onClick={handleNextPage} size="sm">
                        <Icon type="forward" size="sm" />
                    </Button>
                    <Button color="link" onClick={handleGoLast} size="sm">
                        <Icon type="step-forward" size="sm" />
                    </Button>
                </>
            )}
        </ButtonGroup>
    )
}

export default withGridContext(ButtonPager)
